import { Component } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-email',
  templateUrl: './app-email.component.html',
})
export class AppEmailComponent extends FieldComponent { }
